var _global = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

_global.SENTRY_RELEASE = {
  id: "2406589fc35bd64011743ef5e0d26da6e75258fc"
};
_global.SENTRY_RELEASES = _global.SENTRY_RELEASES || {};
_global.SENTRY_RELEASES["disivo@disivo-sro"] = {
  id: "2406589fc35bd64011743ef5e0d26da6e75258fc"
};